export default {
    name: 'WhatsappCta'
}
